import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import TextField from '@mui/material/TextField';
import TableSortLabel from '@mui/material/TableSortLabel';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { API_BASE_URL, PRODUCTOELIMINAR, PRODUCTOSLISTS, RUTAPRODUCTOSIMAGENES } from '../services/apiConfig';
import { useNavigate } from "react-router-dom";
import { MenuInicial } from "./MenuInicial";
import Cargando from './utils/Cargando.jsx';
import { Container, Breadcrumbs, Typography } from "@mui/material";
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';

const ProductList = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(15); // Número de productos por página
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('id');
  const [order, setOrder] = useState('asc');
  const [expandedImage, setExpandedImage] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedRubro, setSelectedRubro] = useState('');
  const [rubros, setRubros] = useState([]);

  const handleEdit = (product) => {
    // Implementa la lógica para editar el producto aquí
    //console.log(`Editar el producto con ID ${product.id}`);
    navigate('/ProductoAMC', { state: { productToEdit: product } });
  
  };


  const handleClickNew = () => {
    navigate('/productoAMC', { state: { productToEdit: null } });
  };

  
  useEffect(() => {
    // Tu lógica existente para obtener los productos
    
    // Obtener rubros únicos
    const uniqueRubros = [...new Set(products.map((product) => product.rubro))];
    setRubros(uniqueRubros);
  }, [products]);
  

  const handleDeleteConfirmation = (confirmed) => {
    if (confirmed) {
      handleDelete(selectedProductId);
    }
    setDeleteDialogOpen(false);
    setSelectedProductId(null);
  };


  const handleDelete = async (productId) => {
    // Implementa la lógica para eliminar el producto aquí
    console.log(`Eliminar el producto con ID ${productId}`);
    
    try {
      const response = await axios.post(API_BASE_URL + PRODUCTOELIMINAR, {
        productoid: productId,
        ruta: RUTAPRODUCTOSIMAGENES
      });
    
      console.log('Producto eliminado:', response.data);
      fetchProducts();
      // Puedes hacer otra llamada a la API para obtener la lista actualizada
    } catch (error) {
      console.error('Error al eliminar el producto:', error);
    }

  };

  const handleImageClick = (image) => {
    setExpandedImage(image);
  };

  const handleCloseImageDialog = () => {
    setExpandedImage(null);
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.get(API_BASE_URL + PRODUCTOSLISTS); 
      setProducts(response.data);
      setLoading(false);
      const uniqueRubros = [...new Set(response.data.map((product) => product.rubro))];
      setRubros(uniqueRubros);
    } catch (error) {
      console.error('Error al cargar los productos', error);
      setLoading(false);
    }
  };

  const filteredProducts = Array.isArray(products)
  ? products
      .filter((product) => product.nombre.toLowerCase().includes(search.toLowerCase()))
      .filter((product) => selectedRubro === '' || product.rubro === selectedRubro)
  : [];


  useEffect(() => {
    /*const loggedIn = sessionStorage.getItem("loggedIn");
    if (!loggedIn) {
      navigate("/login");
    }
*/
    const uniqueRubros = [...new Set(products.map((product) => product.rubro))];
    setRubros(uniqueRubros);

    fetchProducts();
  }, []);

  const handleRubroChange = (event) => {
    setSelectedRubro(event.target.value);
    setCurrentPage(1); // Restablece la página a la primera cuando se realiza un cambio en el filtro
  };
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;



  const sortedProducts = filteredProducts
    .sort((a, b) => {
      if (order === 'asc') {
        return a[orderBy] > b[orderBy] ? 1 : -1;
      } else {
        return a[orderBy] < b[orderBy] ? 1 : -1;
      }
    });

  const currentProducts = sortedProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const paginate = (event, page) => {
    setCurrentPage(page);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setCurrentPage(1); // Restablece la página a la primera cuando se realiza una búsqueda
  };

  const handleSort = (columnId) => {
    if (columnId === orderBy) {
      setOrder(order === 'asc' ? 'desc' : 'asc');
    } else {
      setOrderBy(columnId);
      setOrder('asc');
    }
  };

  return (
    <div>

      
      <Container>
        <MenuInicial></MenuInicial>
       
       

        <div className='miDiv'><h2>Productos</h2></div>

        <div    style={{ marginBottom: '16px' }} >
            <Button onClick={() => handleClickNew()} variant="contained" color="primary">
             Nuevo Producto
            </Button>
          </div>
       

        {loading ? (
          <Cargando></Cargando>
        ) : (
          <div>

                <TextField
                    label="Buscar por nombre del producto"
                    variant="outlined"
                    fullWidth
                    value={search}
                    onChange={handleSearchChange}
                    style={{ marginBottom: '16px' }} // Añade un margen inferior
                />

                <TextField
                  select
                  label=""
                  variant="outlined"
                  fullWidth
                  value={selectedRubro}
                  onChange={handleRubroChange}
                  SelectProps={{
                    native: true,
                  }}
                  style={{ marginBottom: '16px' }} // Añade un margen inferior
                >
                  <option value="">Todos los Rubros</option>
                  {rubros.map((rubro) => (
                    <option key={rubro} value={rubro}>
                      {rubro}
                    </option>
                  ))}
                </TextField>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'id'}
                        direction={orderBy === 'id' ? order : 'asc'}
                        onClick={() => handleSort('id')}
                      >
                        ID
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'nombre'}
                        direction={orderBy === 'nombre' ? order : 'asc'}
                        onClick={() => handleSort('nombre')}
                      >
                        Nombre
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'rubro'}
                        direction={orderBy === 'rubro' ? order : 'asc'}
                        onClick={() => handleSort('rubro')}
                      >
                        Rubro
                      </TableSortLabel>
                    </TableCell>

                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'descripcion'}
                        direction={orderBy === 'descripcion' ? order : 'asc'}
                        onClick={() => handleSort('descripcion')}
                      >
                        Descripción
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'precio'}
                        direction={orderBy === 'precio' ? order : 'asc'}
                        onClick={() => handleSort('precio')}
                      >
                        Unidades
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'unidades'}
                        direction={orderBy === 'unidades' ? order : 'asc'}
                        onClick={() => handleSort('unidades')}
                      >
                        Precio
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'activo'}
                        direction={orderBy === 'activo' ? order : 'asc'}
                        onClick={() => handleSort('activo')}
                      >
                        Activo
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === 'imagen'}
                        direction={orderBy === 'imagen' ? order : 'asc'}
                        onClick={() => handleSort('imagen')}
                      >
                        Imagen
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentProducts.map((product) => (
                    <TableRow key={product.id}>
                      <TableCell>{product.id }</TableCell>
                      <TableCell>{product.nombre + " "+ product.activo}</TableCell>
                      <TableCell>{product.rubro}</TableCell>
                      <TableCell>{product.descripcion}</TableCell>
                      <TableCell>{product.unidades}</TableCell>
                      <TableCell>{product.precio}</TableCell>
                      <TableCell>
                        <Checkbox checked={product.activo === "1" || product.activo === 1} />
                      </TableCell>
                      <TableCell>
                        <img
                          src={RUTAPRODUCTOSIMAGENES + "/" + product.fotos}
                         
                          style={{ maxWidth: '50px', maxHeight: '50px', cursor: 'pointer' }}
                          onClick={() => handleImageClick( RUTAPRODUCTOSIMAGENES + "/" + product.fotos )}
                        />
                      </TableCell>
                      <TableCell>
                        <Button onClick={() => handleEdit(product)}>Editar</Button>
      

                        
                        <Button onClick={() => {
                          setSelectedProductId(product.id);
                          setDeleteDialogOpen(true);
                        }}>Eliminar</Button>


                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Pagination
              count={Math.ceil(sortedProducts.length / productsPerPage)}
              page={currentPage}
              onChange={paginate}
            />

            <Dialog open={!!expandedImage} onClose={handleCloseImageDialog}>
              <DialogContent>
                <img
                  src={expandedImage}
                  alt="Imagen ampliada"
                  style={{ width: '100%' }}
                />
              </DialogContent>
            </Dialog>

            <Dialog open={deleteDialogOpen} onClose={() => handleDeleteConfirmation(false)}>
        <DialogContent>
          <Typography>¿Estás seguro de que quieres eliminar este producto?</Typography>
          <Button onClick={() => handleDeleteConfirmation(true)}>Sí</Button>
          <Button onClick={() => handleDeleteConfirmation(false)}>No</Button>
        </DialogContent>
      </Dialog>


          </div>
        )}
      </Container>
    </div>
  );
};

export default ProductList;
